const KEY = 'abriron_restaurant_layout_last_branch'

export function getLastBranchId () {
  try {
    const id = window.localStorage.getItem(KEY)
    return id === null || id === '' ? null : id
  } catch (e) {
    return null
  }
}

export function setLastBranchId (branchId) {
  try {
    if (branchId != null) {
      window.localStorage.setItem(KEY, String(branchId))
    }
  } catch (e) {}
}
